<script>
  // @ts-nocheck
  import Screen from '../Screen.svelte';
  import AppNavigation from './AppNavigation.svelte';

  export let isWithSearch = true;
  export let keyword;
  export let redirectTo = '/';
</script>

<header aria-label="Site Header">
  <AppNavigation {redirectTo} />

  {#if isWithSearch}
    <Screen>
      <slot name="header" />

      <div class="relative">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg
            aria-hidden="true"
            class="w-5 h-5 text-slate-600 dark:text-slate-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <input
          bind:value={keyword}
          type="search"
          id="search"
          class="block w-full p-4 pl-10 mb-8 text-sm text-slate-900 border border-gray-300 rounded-xl bg-gray-50 focus:border-indigo-500 outline-offset-0"
          placeholder="Search app name, description, categories..."
          required
        />
      </div>
    </Screen>
  {:else}
    <slot name="header" />
  {/if}
</header>
